module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-01-aba244da32150866caf9e025fbde29a5.svg";